
<component :is="tag" role="rowgroup">
  <slot></slot>
</component>
